export type Locale = 'en' | 'zh';

export const SUPPORTED_LOCALES: Locale[] = ['en', 'zh'];

export interface Strings {
  tagline: string;
  subtagline: string;
  comingSoon: string;
  featuredHeading: string;
  whyHeading: string;
  valuePrivacy: string;
  valueNoLogin: string;
  valueOpen: string;
  valueSolo: string;
  notifyCta: string;
  notifyPlaceholder: string;
  notifyThanks: string;
  footer: string;
  localeToggle: string;
  toolComingSoon: (name: string) => string;
  backHome: string;
}

export const STRINGS: Record<Locale, Strings> = {
  en: {
    tagline: '57 productivity tools.',
    subtagline: 'No login. Privacy first.',
    comingSoon: 'Coming Soon - 57 tools',
    featuredHeading: 'Featured tools (Q1 2026 launch)',
    whyHeading: 'Why PocketLedger',
    valuePrivacy: '100% client-side (your data stays on device)',
    valueNoLogin: 'No login required',
    valueOpen: 'Open source and transparent',
    valueSolo: 'Built by 1 person, for everyone',
    notifyCta: 'Get notified when we launch',
    notifyPlaceholder: 'you@example.com',
    notifyThanks: 'Thanks. We will email you when tools launch.',
    footer: 'PocketLedger - personal productivity tools, in your browser.',
    localeToggle: '中',
    toolComingSoon: (name) => `${name} - coming soon`,
    backHome: 'Back to all tools',
  },
  zh: {
    tagline: '57 个效率工具。',
    subtagline: '无需登录，隐私优先。',
    comingSoon: '即将上线 - 57 个工具',
    featuredHeading: 'Q1 2026 首发工具',
    whyHeading: '为什么选 PocketLedger',
    valuePrivacy: '100% 客户端运行（数据不离开设备）',
    valueNoLogin: '无需注册',
    valueOpen: '开源透明',
    valueSolo: '1 人开发，为所有人',
    notifyCta: '上线时通知我',
    notifyPlaceholder: 'you@example.com',
    notifyThanks: '感谢。上线时会发邮件给你。',
    footer: 'PocketLedger - 浏览器里的个人效率工具。',
    localeToggle: 'EN',
    toolComingSoon: (name) => `${name} - 即将上线`,
    backHome: '返回工具列表',
  },
};
